import React from 'react'
import './mycarouselcomp.css'
import Carousel from 'react-bootstrap/Carousel'
import Slide1 from '../../assets/computer.jpg'
import Slide2 from '../../assets/computer2.jpg'
import Slide3 from '../../assets/computer3.jpg'
import ScrollDown from '../scroll-down/scrollDown'

const mycarouselcomp = () => {
    return (
        <>
                <Carousel controls={false} indicators interval={2500} pauseOnHover={false}>
  <Carousel.Item>
    <img
      className="d-block w-100 custom-img"
      src={Slide1}
      alt="First slide"
    />
    
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100 custom-img"
      src={Slide2}
      alt="Third slide"
    />

    
  </Carousel.Item>
  <Carousel.Item>
    <img
      className="d-block w-100 custom-img"
      src={Slide3}
      alt="Third slide"
    />

    
  </Carousel.Item>
</Carousel>
<ScrollDown />
        </>
    )
}

export default mycarouselcomp
